import React, { useState } from "react";
import SvgIcon from "../../../../../assets/icons/SvgIcon";
import { AWS_BASE_URL } from "../../../../../clientConfig";
import { LOCAL_STORAGE_KEYS } from "../../../../../constants";
import ClientEnquirySection from "./ClientEnquirySection";
import FetchImages from "../../../../../constants/imagePath";
import Rating from "../../../../../components/Rating";
import {
  giveAgentRating,
  updateAgentRating,
} from "../../../../../services/customer/property";
import { downloadFn, getLocalStorage } from "../../../../../utils";
import EmiCalculate from "./EmiCalculate";

interface RightSideSectionProps {
  projectData: any;
  enquiryCreate: () => void;
  authModel: () => void;
  alreadyRequestTour: any;
  setAlreadyRequestTour: any;
  basePrice: number;
}

const RightSideSection: React.FC<RightSideSectionProps> = ({
  projectData,
  authModel,
  enquiryCreate,
  alreadyRequestTour,
  setAlreadyRequestTour,
  basePrice,
}) => {
  const authToken = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const userId = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ID);
  const [rating, setRating] = useState(projectData?.rating_given_by_me ?? 0);
  const [agentRatingLoading, setAgentRatingLoading] = useState<boolean>(false);
  const [averageRating, setAverageRating] = useState<number | null>(null);

  const handleAgentRating = (ratingValue: number) => {
    if (rating !== ratingValue) {
      const data = {
        agent_id: projectData?.agent?._id,
        rating: ratingValue,
      };

      if (projectData?.given_by_me || rating) {
        updateAgentRating(data, setAgentRatingLoading, (responseData: any) => {
          setRating(responseData?.rating_given_by_me);
          setAverageRating(responseData?.average_rating);
        });
      } else {
        giveAgentRating(data, setAgentRatingLoading, (responseData: any) => {
          setRating(responseData?.rating_given_by_me);
          setAverageRating(responseData?.average_rating);
        });
      }
    }
  };
  return (
    <div className="top-40 sticky space-y-6">
      <div className="space-y-3 shadow-[0px_4px_4px_0px_#00000029] p-4 border rounded-md">
        <h2 className="font-normal text-deep-teal text-2xl md:text-3xl text-center">
          Reach Out to <span className="font-black text-dark-cyan">Seller</span>
        </h2>
        <div className="space-y-4">
          <div className="p-4 border rounded-md project-gray-section">
            <div className="space-y-8">
              <div className="flex small:flex-row flex-col justify-start items-center sm:items-start gap-6">
                <div className="small:m-0 mx-auto mt-3 rounded-full overflow-hidden">
                  <img
                    src={
                      projectData?.agent?.profile
                        ? `${AWS_BASE_URL}${projectData?.agent?.profile}`
                        : ""
                    }
                    alt="not found"
                    onError={(e: any) =>
                      (e.target.src = FetchImages.IMAGE_USER_DEFAULT)
                    }
                    className="size-20 small:size-16 object-cover"
                  />
                </div>
                <div className="small:text-left text-center">
                  <div className="flex justify-start items-center gap-4">
                    <h2 className="font-bold text-black text-xl line-clamp-1">
                      {projectData?.agent?.full_name}
                    </h2>
                    <div className="flex justify-center small:justify-start items-center">
                      <span className="mt-1 font-semibold">
                        {(averageRating?.toFixed(1) ||
                          projectData?.agent_rating?.toFixed(1)) ??
                          0}
                      </span>
                      <span
                        className="ml-2 text-2xl cursor-pointer"
                        style={{
                          color: "#ffc107",
                        }}
                      >
                        ★
                      </span>
                    </div>
                  </div>
                  <Rating
                    loading={agentRatingLoading}
                    rating={rating}
                    setRating={handleAgentRating}
                    handleWithOutLogin={authModel}
                    disabled={userId === projectData?.agent?._id}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="bottom-0 left-0 z-[99999] lg:static fixed bg-white shadow p-4 border-t w-full"> */}
          {projectData && (
            <ClientEnquirySection
              btnRequestClassName="!w-full !text-base !py-2 max-xs:!font-medium"
              btnContactClassName="!w-full !text-base !py-2 max-xs:!text-base !text-lg max-xs:font-medium"
              className="flex flex-wrap gap-4 w-full"
              projectData={projectData}
              alreadyRequestTour={alreadyRequestTour}
              setAlreadyRequestTour={setAlreadyRequestTour}
            />
          )}
          {/* </div> */}
        </div>
      </div>
      <div className="space-y-8 shadow shadow-black/20 border rounded-md">
        <button
          className="flex justify-center items-center gap-x-3 mx-auto p-4 w-full"
          onClick={() => {
            if (authToken) {
              enquiryCreate();
              downloadFn(projectData?.brochure);
            } else {
              authModel();
            }
          }}
        >
          <SvgIcon iconName="download" className="" />
          <h2 className="font-semibold text-black text-lg md:text-xl">
            Download Brochure
          </h2>
        </button>
      </div>
      {basePrice !== 0 ? <EmiCalculate baseAmount={basePrice} /> : null}
    </div>
  );
};

export default RightSideSection;
